import * as React from 'react';
const X = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="none"
		{...props}
	>
		<rect
			width={2.514}
			height={20.113}
			x={18.223}
			y={4}
			rx={1.257}
			transform="rotate(45 18.223 4)"
		/>
		<rect
			width={2.514}
			height={20.113}
			x={20}
			y={18.222}
			rx={1.257}
			transform="rotate(135 20 18.222)"
		/>
	</svg>
);
export default X;
